import { relocationWidgetStore } from "../store/RelocationWidgetStore";
import type {
  ContractPartner,
  Contract,
  LoginResponse,
} from "../types/LegacySystemAPI";

const prodBaseUrl = "https://api.mittwald.de/v1";
const devBaseUrl = "https://api-public.dev.mittwald.systems/v1";

const baseUrl =
  import.meta.env.MODE === "development" ? devBaseUrl : prodBaseUrl;
const relocationWidgetStoreState = relocationWidgetStore;

export class LegacySystemAPI {
  public static login = async (
    customerNumber: string,
    password: string,
    multiFactorCode?: string,
  ): Promise<LoginResponse> => {
    const response = await fetch(baseUrl + "/authenticate", {
      method: "POST",
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: customerNumber,
        password: password,
        multiFactorCode: multiFactorCode,
      }),
    });

    return await response.json();
  };

  public static getContracts = async (
    customerNumber: string,
  ): Promise<Contract[]> => {
    const response = await fetch(
      `${baseUrl}/customers/${customerNumber}/contracts`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${relocationWidgetStoreState.accessToken}`,
        },
      },
    );

    return await response.json();
  };

  public static getContractPartner = async (
    customerNumber: string,
  ): Promise<ContractPartner> => {
    const response = await fetch(
      `${baseUrl}/customers/${customerNumber}/contractpartner`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${relocationWidgetStoreState.accessToken}`,
        },
      },
    );

    return await response.json();
  };
}
